import FeatureCards from './features-card';

export default FeatureCards;
